<template>
    <div>
      <h4>Activités de garde</h4>
        
      <data-table
        :data-source="activities"
        :headers="headers"
        table-class="table-striped table-hover"
      >
        <template slot="actions">
          <a
            href="javascript:void(0)"
            class="btn btn-outline-primary btn-icon"
            data-toggle="modal"
            data-target="#add-activity-garde"
          >
            <i class="icofont icofont-plus" />
          </a>
        </template>
      </data-table>
            
      <modal
        title="Ajout d'une activité de garde"
        id="add-activity-garde"
        :footer="false"
      >
        <form
          class="form-horizontal"
          @submit.prevent="adding"
        >
          <div
            class="alert alert-danger"
            v-if="has_error"
          >
            {{ error_msg }}
          </div>
          <div class="form-group">
            <label for="add-libelle">Libelle</label>
            <input
              id="add-libelle"
              name="add-libelle"
              type="text"
              class="form-control"
              v-model="libelle"
            >
          </div>
          <div class="form-group">
            <label for="add-code">Code</label>
            <input
              id="add-code"
              name="add-code"
              type="text"
              class="form-control"
              v-model="code"
            >
          </div>

          <div class="form-group">
            <label for="add-amount">Montant</label>
            <input
              id="add-amount"
              name="add-amount"
              type="text"
              class="form-control"
              v-model="amount"
            >
          </div>
          <div class="form-group text-right">
            <button
              type="submit"
              class="btn btn-primary"
            >
              Ajouter
            </button>
          </div>
        </form>
      </modal>
    
      <modal
        title="Modification d'une activité de garde"
        id="update-activity-garde"
        :footer="false"
      >
        <form
          class="form-horizontal"
          @submit.prevent="editing"
        >
          <div
            class="alert alert-danger"
            v-if="has_error"
          >
            {{ error_msg }}
          </div>
          <div class="form-group">
            <label for="update-libelle">Libelle</label>
            <input
              id="update-libelle"
              name="update-libelle"
              type="text"
              class="form-control"
              v-model="libelle"
            >
          </div>
          <div class="form-group">
            <label for="update-code">Code</label>
            <input
              id="update-code"
              name="update-code"
              type="text"
              class="form-control"
              v-model="code"
            >
          </div>
          <div class="form-group">
            <label for="update-amount">Montant</label>
            <input
              id="update-amount"
              name="update-amount"
              type="text"
              class="form-control"
              v-model="amount"
            >
          </div>
          <div class="form-group text-right">
            <button
              type="submit"
              class="btn btn-primary"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </modal>
    </div>
  </template>
    
    <script>
    import {mapGetters, mapMutations} from 'vuex'
    import DataTable from '../../../components/dataTable/local.vue'
    import { COMPONENT_TYPE, NUMERIC_TYPE, TEXT_TYPE } from '../../../components/dataTable/dataType'
    import Modal from '../../../components/modal.vue'
    import { Select } from '../../../directive/select'
    import { ADD_GARDE_ACTIVITY, UPDATE_GARDE_ACTIVITY} from '../../../graphql/garderie'
    const Actions = () => import('../../../components/admin/garderie/activityActions.vue')
    export default {
        components: { DataTable, Modal},
        directives: {Select},
        data(){
            return {
                libelle: null,
                code: null,
                amount: null,
                has_error: false,
                error_msg: null
            }
        },
        watch: {
            selectedType: {
                handler(){
                    if(this.selectedType !== null) {
                        this.libelle = this.selectedType.libelle
                        this.code = this.selectedType.code
                        this.amount = this.selectedType.amount
                    }
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations({
                done: 'DONE',
                setSelectedObject: 'SET_SELECTED_OBJECT'
            }),
            initForm(){
                this.setSelectedObject(null)
                this.libelle = null
                this.code = null
                this.amount = null
                this.has_error = false
                this.error_msg = null
            },
            adding(){
                let data = {
                    libelle: this.libelle,
                    code: this.code,
                    amount: parseFloat(this.amount)
                }
                this.$apollo.mutate({
                    mutation: ADD_GARDE_ACTIVITY,
                    variables: {
                        "activity": {...data}
                    },
                    update: (d) => {
                        console.log(d)
                        console.log(`Activité de garde ${this.libelle} add successfully`)
                    }
                  }).then(() => {
                    this.initForm()
                    this.done()
                }).catch((error) => {
                    console.error(error)
                    this.has_error = true
                    this.error_msg = error
                })
            },
            editing(){
                let data = {
                    libelle: this.libelle,
                    code: this.code,
                    amount: parseFloat(this.amount)
                }
                this.$apollo.mutate({
                    mutation: UPDATE_GARDE_ACTIVITY,
                    variables: {
                        "activity": {...data},
                        "uid": this.selectedType.uid
                    },
                    update: (d) => {
                        console.log(d)
                        console.log(`Activity de garde ${this.libelle} on ${this.selectedType.uid} updated successfully`)
                    }
                  }).then(() => {
                    this.initForm()
                    this.done()
                }).catch((error) => {
                    console.error(error)
                    this.has_error = true
                    this.error_msg = error
                })
            }
        },
        computed: {
            ...mapGetters({
                activities: 'garderie/activities',
                selectedType: 'selectedObject'
            }),
            
            headers(){
                return [
                    {label: 'ID', name: 'uid', type: TEXT_TYPE},
                    {label: 'Libelle', name: 'libelle', type: TEXT_TYPE},
                    {label: 'Code', name: 'code', type: TEXT_TYPE},
                    {label: 'Montant (Fcfa)', name: 'amount', type: NUMERIC_TYPE, sortable: true},
                    {label: 'Actions', name: 'action', type: COMPONENT_TYPE, component: Actions}
                ]
            }
        }
    }
    </script>
    
    <style>
    
    </style>